(function () {
  if (typeof window === 'undefined') return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var els = [];
  var ticking = false;

  function collect() {
    els = Array.prototype.slice.call(document.querySelectorAll('[data-hs-parallax]'));
  }

  function update() {
    var viewportH = window.innerHeight || document.documentElement.clientHeight;
    els.forEach(function (el) {
      var container = el.closest('[data-hs-parallax-viewport]') || el.parentElement;
      var rect = container.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > viewportH) return;
      var progress = (rect.top) / viewportH;
      var offset = progress * -40;
      el.style.transform = 'translateY(' + offset + 'px) scale(1.15)';
    });
    ticking = false;
  }

  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(update);
      ticking = true;
    }
  }

  function init() {
    collect();
    if (!els.length) return;
    update();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function () {
    collect();
    update();
  });
})();
